import React from 'react';
import SEO from '../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './Dental.css';

const Dental = () => {
    return (
        <div className="industry-page">
            <SEO 
                title="Dental Services | Digi Network" 
                description="Learn more about our Dental services to grow your business online with Digi Network." 
                canonical="/industries/dental/dental" 
            />

            <section className="industry-hero">
                <div className="industry-hero-bg"></div>
                <div className="container">
                    <div className="industry-hero-content">
                        <div className="label">Dental Industry</div>
                        <h1>Digital Marketing for Dental Practices</h1>
                        <p>Attract new patients, build trust, and grow your dental practice with compliant digital marketing strategies designed for dental professionals. We understand the unique challenges dental practices face in today's competitive healthcare market.</p>
                        <div className="industry-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                                Get Started
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </Link>
                            <Link to="/case-studies" className="btn btn-outline">View Results</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="hero-image-section">
                <div className="container">
                    <div className="image-placeholder-large">
                        <p>📷 Add Dental Hero Image (1200x500px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-services">
                <div className="container">
                    <h2>Dental Marketing Services</h2>
                    <p className="section-intro">Comprehensive marketing solutions tailored for dental practices</p>
                    <div className="services-grid">
                        <div className="service-card">
                            <h3>Dental SEO</h3>
                            <p>Rank for local dental searches, attract patients in your area, and build authority in your specialty. Our dental SEO strategies help practices dominate local search results and attract qualified patients.</p>
                            <ul>
                                <li>Local SEO for dental practices</li>
                                <li>Dental service optimization</li>
                                <li>Google My Business for dentists</li>
                                <li>Review management</li>
                                <li>Dental directory listings</li>
                                <li>Treatment page optimization</li>
                            </ul>
                            <Link to="/industries/dental/seo" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Dental Paid Ads</h3>
                            <p>Drive new patient appointments with targeted advertising campaigns that showcase your services. Our targeted ad campaigns reach people actively searching for dental services in your area.</p>
                            <ul>
                                <li>Google Ads for dental practices</li>
                                <li>Facebook & Instagram ads</li>
                                <li>Dental service promotions</li>
                                <li>New patient acquisition</li>
                                <li>Retargeting strategies</li>
                                <li>Conversion tracking & optimization</li>
                            </ul>
                            <Link to="/industries/dental/paid-ads" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Dental Website Design</h3>
                            <p>Patient-friendly dental websites with online booking, service information, and before/after galleries. Our dental websites are designed to build trust and make it easy for patients to book appointments.</p>
                            <ul>
                                <li>Dental practice websites</li>
                                <li>Online appointment booking</li>
                                <li>Virtual consultation forms</li>
                                <li>Patient portal integration</li>
                                <li>Mobile-responsive design</li>
                                <li>Treatment galleries</li>
                            </ul>
                            <Link to="/industries/dental/web-development" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Dental Email Marketing</h3>
                            <p>Nurture patient relationships with appointment reminders, oral health tips, and special offers. Build lasting relationships with patients through strategic email communication that provides value.</p>
                            <ul>
                                <li>Appointment reminder campaigns</li>
                                <li>Oral health newsletters</li>
                                <li>Patient retention emails</li>
                                <li>Treatment follow-up sequences</li>
                                <li>Promotional campaigns</li>
                                <li>Recall reminders</li>
                            </ul>
                            <Link to="/industries/dental/email-marketing" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Dental CRM & Automation</h3>
                            <p>Manage patient leads, automate follow-ups, and streamline operations with GoHighLevel for dental. Automate your patient management and communication workflows to improve satisfaction.</p>
                            <ul>
                                <li>Patient lead management</li>
                                <li>Appointment confirmation automation</li>
                                <li>Treatment plan follow-ups</li>
                                <li>Recall appointment reminders</li>
                                <li>Patient satisfaction tracking</li>
                                <li>Referral tracking</li>
                            </ul>
                            <Link to="/industries/dental/all-in-one" className="service-link">Learn More →</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="process-section">
                <div className="container">
                    <h2 className="process-item-title">Our Dental Marketing Process</h2>
                    <p className="section-intro">A proven methodology designed specifically for dental practices</p>
                    <div className="process-grid">
                        <div className="process-item">
                            <div className="process-number">1</div>
                            <h3>Practice Analysis</h3>
                            <p>We analyze your dental practice, target patients, and competitive landscape to understand your unique positioning. Our team conducts comprehensive audits of your current online presence and patient acquisition strategies.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">2</div>
                            <h3>Compliance-First Strategy</h3>
                            <p>We develop a customized marketing strategy that complies with healthcare advertising regulations and ethical guidelines. Every tactic is designed to maintain compliance while maximizing patient acquisition.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">3</div>
                            <h3>Trust Building</h3>
                            <p>We implement strategies to build trust and credibility with potential patients. From professional websites to positive reviews, we position your practice as the go-to dental provider in your area.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">4</div>
                            <h3>Patient Acquisition & Retention</h3>
                            <p>We generate qualified leads and nurture them through automated follow-up sequences. Our CRM system helps you track every lead and convert more prospects into patients.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Dental Process Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="why-choose">
                <div className="container">
                    <h2>Why Dental Practices Choose Digi Network</h2>
                    <p className="why-intro">Trusted by dental professionals across the UAE and internationally</p>
                    <div className="why-grid">
                        <div className="why-item">
                            <div className="why-number">01</div>
                            <h3>HIPAA Compliant</h3>
                            <p>All our marketing strategies comply with HIPAA regulations and dental industry standards. We understand the strict regulations governing dental marketing and ensure every campaign meets these standards.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">02</div>
                            <h3>Dental Industry Expertise</h3>
                            <p>We understand the dental market and create campaigns that attract quality patients. Our team has extensive experience working with dental practices across various specialties.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">03</div>
                            <h3>Patient Acquisition Focus</h3>
                            <p>Every strategy is designed to attract new patients and fill your appointment calendar. We understand that dental practices need a steady stream of new patients to grow.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">04</div>
                            <h3>Proven Results</h3>
                            <p>We've helped dental practices increase new patient appointments by 280%+ through targeted marketing. Our data-driven approach delivers measurable results that directly impact your practice.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="benefits-section">
                <div className="container">
                    <h2>Key Benefits for Dental Practices</h2>
                    <p className="section-intro">How our marketing services help you grow your dental practice</p>
                    <div className="benefits-grid">
                        <div className="benefit-item">
                            <h3>More New Patients</h3>
                            <p>Attract more qualified patients through targeted marketing campaigns that reach people actively searching for dental services. Our strategies focus on converting high-intent searches into appointments.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Better Online Visibility</h3>
                            <p>Dominate local search results for dental services and build a strong online presence. When potential patients search for dental services, they'll find your practice first.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Improved Patient Trust</h3>
                            <p>Build credibility and trust through professional online presence, positive reviews, and educational content. Patients are more likely to choose practices with strong online reputations.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Streamlined Operations</h3>
                            <p>Automate patient communication, appointment reminders, and follow-ups to reduce administrative burden and improve patient satisfaction.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Better ROI Tracking</h3>
                            <p>Understand exactly which marketing channels deliver the best results with comprehensive tracking and reporting. Make data-driven decisions about your marketing spend.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Competitive Advantage</h3>
                            <p>Stay ahead of competitors with cutting-edge marketing strategies and technology. Many dental practices still rely on outdated marketing methods.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Dental Benefits Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-cta">
                <div className="container">
                    <h2>Ready to Grow Your Dental Practice?</h2>
                    <p>Let's discuss how we can help you attract more patients and build your dental practice online.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Book a Free Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Dental;
